import i18n from "i18n";

// label / court sont des getters : toujours dans la langue courante de l'interface
const jour = (value) => ({
  value,
  get label() { return i18n.t(`valeurs.jours.${value}`); },
  get court() { return i18n.t(`valeurs.joursCourts.${value}`); },
});

export const JOURS = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"].map(jour);

// jours_semaine est stocké en texte JSON : '["lundi","mercredi"]'
export const parseJours = (value) => {
  if (Array.isArray(value)) return value;
  try {
    const jours = JSON.parse(value || "[]");
    return Array.isArray(jours) ? jours : [];
  } catch {
    return [];
  }
};

export const trierJours = (jours) =>
  JOURS.map((j) => j.value).filter((v) => jours.includes(v));

// "18:00:00" → "18h00" (fr) / "18:00" (ar, en)
export const formatHeure = (heure) => {
  if (!heure) return "";
  const [h, m] = heure.split(":");
  return i18n.t("planning.heure", { h, m: m || "00" });
};

// { jours_semaine: ["lundi","mercredi"], heure_cours: "18:00:00" } → "Tous les Lundi, Mercredi à 18h00"
export const formatPlanning = (cours) => {
  if (!cours) return "";
  const jours = trierJours(parseJours(cours.jours_semaine))
    .map((v) => JOURS.find((j) => j.value === v).label)
    .join(i18n.t("planning.separateur"));
  const heure = formatHeure(cours.heure_cours);
  if (jours && heure) return i18n.t("planning.joursHeure", { jours, heure });
  if (jours) return i18n.t("planning.jours", { jours });
  return heure ? i18n.t("planning.aHeure", { heure }) : "";
};
